import { IState } from '../../../store';

export function getIsFlatViewOrderEnabled(state: IState): boolean {
  return Boolean(state.offerData?.newbuildingFlatViewOrder?.isEnabled);
}
